export class Step4 {
    constructor() {}
    intitule = 'stepper.form.mapa_re.step4';
    getspan6 = 'form.mapa_re.getspan6';
    getspan6_1 = 'form.mapa_re.getspan6_1';
    getspan68 = 'form.mapa_re.getspan68';
    getrubdelais = 'form.mapa_re.getrubdelais';
    getspan7 = 'form.mapa_re.getspan7';
    getliredate = 'form.mapa_re.getliredate';
    getspan8 = 'form.mapa_re.getspan8';
    getspan8_1 = 'form.mapa_re.getspan8_1';
    getrubrique = 'form.mapa_re.getrubrique';
    getapreslamention = 'form.mapa_re.getapreslamention';
    getaulieude = 'form.mapa_re.getaulieude';
    getajouter = 'form.mapa_re.getajouter';
    getlire = 'form.mapa_re.getlire';
    getsupprimer = 'form.mapa_re.getsupprimer';
    ajouter = 'boutons.ajouter';
    supprimer = 'boutons.supprimer';
    

}
